import { Directive, Input, ViewContainerRef } from "@angular/core";

@Directive({
  selector: "[medHost]",
})
export class MedHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }

  @Input("medHost") name = "";
}
